import Vue from 'vue';
import { DateTime } from 'luxon';
import { formatDateTime, baseurl } from '@/helpers/Utils';

Vue.filter('datetime', function(value: DateTime|Date|string, format: string = 'yyyy-MM-dd HH:mm:ss', zone: string = null)
{
    return formatDateTime(value, format, zone);
});
Vue.filter('date', function(value: DateTime|Date|string, format: string = 'yyyy-MM-dd', zone: string = null)
{
    return formatDateTime(value, format, zone);
});
Vue.filter('baseurl', function(value: string)
{
    return baseurl(value);
});
Vue.filter('image', function(value: string, presetName: string)
{
    return baseurl(`${value}?p=${presetName}`);
});
Vue.filter('filesize', function(size: number)
{
    let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let i = 0;

    for (i = 0; size > 1024; i++)
    {
        size = size / 1024;
    }

    return `${size.toFixed(2)} ${units[i]}`;
});
